import React, { Component, Suspense } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import $ from 'jquery';
import {
  AppFooter,
  AppHeader
} from '@coreui/react';

import { defaultProps } from 'recompose';


const AppFooterNoMargin = styled(AppFooter)`
  margin-top: 0px !important;
`;

const Footer = React.lazy(() => import('./RenterFooter'));
const RenterHeader = React.lazy(() => import('./RenterHeader'));
const CommonHeader = React.lazy(() => import('../common/CommonHeader'));

class RenterLayout extends Component {
  loading = () => (
    <div className="animated fadeIn pt-1 text-center">
      <div className="sk-spinner sk-spinner-pulse" />
    </div>
  );

  componentDidMount(){
    $('body').removeClass('sidebar-lg-show');
    $('body').removeClass('sidebar-fixed');
    $('body').removeClass('header-fixed');
  }

  render() {
    const { pathname } = this.props.location;

    const blacklist = [
      '/login',
      '/register',
      '/reset-password',
      '/set-password'
    ];

    const isBlacklisted = _.findIndex(blacklist, (el) => _.isEqual(el, pathname) || pathname.includes(el)) > -1;
    const headerStyle = isBlacklisted ? 'transparent renter' : 'renter d-flex flex-row justify-content-between renter';
    const FooterComponent = (isBlacklisted) ? AppFooterNoMargin : AppFooter;
    const HeaderComponent = (isBlacklisted) ? (
      <AppHeader className='transparent renter position-absolute w-100'>
        <Suspense fallback={this.loading()}>
          <CommonHeader />
        </Suspense>
      </AppHeader>
    ) : (
      <AppHeader
        className={headerStyle}
        style={{
          position: 'relative',
          zIndex: '1000',
          width: '100%'
        }}
      >
        <Suspense fallback={this.loading()}>
          <RenterHeader {...this.props} />
        </Suspense>
      </AppHeader>
    )

    return (
      <div className="app">
        {HeaderComponent}

        <div className="app-body mt-0">
          <main className="main d-flex flex-column">
            <Suspense fallback={this.loading()}>
              {this.props.children}
            </Suspense>
          </main>
        </div>

        <FooterComponent className="renter" style={{marginTop: '0px'}}>
          <Suspense fallback={this.loading()}>
            <Footer />
          </Suspense>
        </FooterComponent>
      </div>
    )
  }
}

const withDefaults = defaultProps({
  routes: [],
  navigation: { items: [] }
});

export default withDefaults(RenterLayout);
